















/* eslint-disable class-methods-use-this */

import { Vue, Component, Prop } from "vue-property-decorator"; // eslint-disable-line no-unused-vars

@Component({})
export default class CdkFilterPassBadge extends Vue {
  @Prop({
    type: String,
    required: true
  })
  color!: string;

  @Prop({
    type: String,
    default: ""
  })
  name?: string;

  // REVIEW, All booleans could be converted to one enum?
  @Prop({
    type: Boolean,
    default: false
  })
  isPublic!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  isCompact!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  isNav!: boolean;

  stateClassObj({ isPublic, isCompact, isNav }): any {
    return {
      "is-public": isPublic,
      "is-compact": isCompact,
      "is-nav": isNav
    };
  }
}
